import { type Form, type Section, type Tab } from '@app/store/processForms/formDetails';

export const processForms = (forms: Form) => ({
  ...forms,
  tabs: (forms.tabs.map((_tab: Tab) => _tab.id) || []),
});

export const processTabs = (forms: Form) => forms.tabs.reduce((_accumulator, _currentTab) => (
  {
    ..._accumulator,
    [_currentTab.id]: {
      ..._currentTab,
      sections: _currentTab.sections.map((_section) => _section.id),
    },
  }
), {});

export const processSectionAndInputFields = (forms: Form) => {
  const sections: Record<string, Object> = {};
  const inputFields: Record<string, Object> = {};
  forms.tabs.forEach((_currentTab) => {
    const currentTabSections = _currentTab.sections;

    currentTabSections.forEach((_section: Section) => {
      sections[_section.id] = {
        ..._section,
        inputFields: _section.inputFields.toSorted((a, b) => {
          if (a.sequenceNumber !== b.sequenceNumber) return a.sequenceNumber - b.sequenceNumber;

          return Number(a.id) - Number(b.id);
        }).map((_inputField) => _inputField.id),
      };

      _section.inputFields.forEach((_inputField) => {
        inputFields[_inputField.id] = _inputField;
      });
    });
  });

  return {
    sections,
    inputFields,
  };
};

export const processRules = (forms: Form) => {
  const rules: Record<string, Record<string, Array<{
    inputFieldId: string;
    comparator: string;
    values: string[];
  }>>> = {};
  forms.ruleGroups.forEach((_ruleGroup) => {
    const groupRules = _ruleGroup.rules.map((_rule) => ({
      inputFieldId: _rule.entity?.inputField?.id ?? '',
      comparator: _rule.comparator,
      values: _rule.value.value,
    }));

    _ruleGroup.ruleActions.forEach((_ruleAction) => {
      const { actionType } = _ruleAction;
      _ruleAction.ruleActionsOn.forEach((_ruleActionOn) => {
        const inputFieldId = _ruleActionOn.entity?.id ?? '';

        rules[inputFieldId] ||= {};
        const actionTypeRules = rules[inputFieldId][actionType] || [];
        rules[inputFieldId][actionType] = [
          ...actionTypeRules,
          ...groupRules,
        ];
      });
    });
  });

  return rules;
};
